// What each MPG AI tool is called on screen, in the chip while it runs and
// in the "Used N sources" list after. Names match config/ai.php on the API.
const LABELS: Record<string, string> = {
  get_planning_settings: 'Section SLAs and capacity',
  list_products: 'Products',
  plan_what_if: 'Production planner (dry run)',
  get_section_load: 'Section load',
  get_jobs_on_day: 'Jobs booked on a day',
  get_intake_calendar: 'Daily intake',
  get_late_jobs: 'Late jobs',
  list_pending_orders: 'Pending orders',
  get_jobs_at_risk: 'Jobs at risk',
  get_open_issues: 'Open issues',
  get_part_done_balances: 'Part-done balances',
  get_partner_jobs: 'Jobs at warehouse partners',
  get_order: 'Order details',
  get_section_actuals: 'How long sections really took',
  get_issue_summary: 'Flagged issues',
  propose_action: 'Suggested change',
}

export function toolLabel(name?: string | null): string {
  if (!name) return 'Lookup'
  return LABELS[name] ?? name.replace(/_/g, ' ')
}
